import calculateDatesDifferenceInDays from '../calculateDatesDifferenceInDays'

type Params = {
  currentDate: string
  startDate: string
  finalDate: string
}

export const isDateBetweenDatesRanger = ({ currentDate, startDate, finalDate }: Params) => {
  if (!startDate || !finalDate) return false
  const isAboveStartDate = calculateDatesDifferenceInDays(startDate, currentDate)
  if (isAboveStartDate < 0) return false
  const isDownfinalDate = calculateDatesDifferenceInDays(finalDate, currentDate)
  if (isDownfinalDate > 0) return false
  return true
}
